import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useRef } from "react";
import { FormProvider, useForm } from "react-hook-form";

import {
    ListarEmpreendimentosController,
    ListarProdutosPorEmpreendimentosController,
} from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import {
    IEmpreendimento,
    IUnidade,
} from "../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import UnForm from "../../../../Components/Form";
import {
    IVenda,
    IVendaFilter,
} from "../../../../Interfaces/Geral/RegistraVenda/RegistraVendaInterface";
interface IFilterRegistroVendaRow {
    setTotalPaginas: Dispatch<SetStateAction<number>>;
    setLstVendas: Dispatch<SetStateAction<IVenda[]>>;
    setLoading: Dispatch<SetStateAction<boolean>>;
    lstUnidades: IUnidade[];
    setFilter: Dispatch<SetStateAction<IVendaFilter>>;
    setLstUnidades: Dispatch<SetStateAction<IUnidade[]>>;
    lstEmpreendimentos: IEmpreendimento[];
    updateVendas: (page: number, filter: IVendaFilter) => void;
    filter: IVendaFilter;
    setFlag: Dispatch<SetStateAction<number>>;
    setPagina: Dispatch<SetStateAction<number>>;
    setIdEmpreendimento: Dispatch<SetStateAction<string | number[]>>;
    idEmpreendimento: string | number[];
}

export default function FilterRegistroVendaRow(props: IFilterRegistroVendaRow) {
    const FormMethods = useForm<IVendaFilter>();
    const { reset } = FormMethods;
    const filtroInicial = {
        DS_NOME: "",
        DT_VENDA: "",
        ID_EMPREENDIMENTO: 0,
        ID_UNIDADE: 0,
    };

    function handleFilterFormSubmit(formData: IVendaFilter) {
        const filterForm = {
            ...formData,
            ID_EMPREENDIMENTO: formData.ID_EMPREENDIMENTO
                ? formData.ID_EMPREENDIMENTO
                : 0,
        };
        props.setFilter(filterForm);
        sessionStorage.setItem(
            "FILTRO_REGISTRO_VENDAS",
            JSON.stringify({ ...formData })
        );
        props.setPagina(1);
        props.setFlag((value: number) => value + 1);
    }
    const { execute: listarUnidades, value: unidadesListadas } =
        useAsyncCallback(ListarProdutosPorEmpreendimentosController);

    const idEmpreendimentoRef = useRef<any>();

    const limparFiltros = () => {
        idEmpreendimentoRef.current?.clearValue();
    };

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                handleSubmit={handleFilterFormSubmit}
                usingContext
                className="form-group row"
            >
                <div className="col-12 mt-3">
                    <label>Nome</label>
                    <UnForm.Input
                        className="form-control"
                        type="text"
                        {...FormMethods}
                        name="DS_NOME"
                        defaultValue={props.filter.DS_NOME}
                    />
                </div>
                <div className="col-12 mt-3">
                    <UnForm.Input
                        type="date"
                        name="DT_VENDA"
                        label="Data da Venda"
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Empreendimento</label>
                    <UnForm.LazySelect
                        controller={ListarEmpreendimentosController}
                        getDS={(j) => j.DS_EMPREENDIMENTO}
                        getKeyValue={(j) => j.ID_EMPREENDIMENTO}
                        name="ID_EMPREENDIMENTO"
                        onChange={(e) =>
                            listarUnidades({
                                ID_EMPREENDIMENTO: [Number(e.target.value)],
                            })
                        }
                    >
                        <option style={{ display: "none" }}></option>
                    </UnForm.LazySelect>
                </div>
                <div className={`col-12 mt-3 `}>
                    <label>Unidade</label>
                    <UnForm.Select className="form-control" name="ID_UNIDADE">
                        <option value={0}></option>
                        {unidadesListadas?.map((unidade) => (
                            <option
                                key={unidade?.ID_PRODUTO}
                                value={unidade?.ID_PRODUTO}
                            >
                                {unidade.DS_PRODUTO}
                            </option>
                        ))}
                    </UnForm.Select>
                </div>
                <UnForm.SubmitButton
                    color="success"
                    icon={faFilter}
                    type="submit"
                    className="btn btn-block btn-outline-dark mt-4"
                >
                    Filtrar
                </UnForm.SubmitButton>
                <div className="col-12 d-flex align-items-end justify-content-start">
                    <button
                        type="button"
                        onClick={() => {
                            window.sessionStorage.removeItem(
                                "FILTRO_REGISTRO_VENDAS"
                            );

                            reset(filtroInicial);
                            limparFiltros();
                        }}
                        className="btn btn-block btn-outline-danger mt-2"
                    >
                        <FontAwesomeIcon icon={faTimes} className="mr-2" />
                        Limpar Filtros
                    </button>
                </div>
            </UnForm>
        </FormProvider>
    );
}
